import { createAPI } from '@common'

export default {
  // 查看权限 待办
  getAssignStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bttjho0tubuvt', 'get', config),
  // 签发稿件到报纸
  postPaperArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0qbqfs0tjho0gpsxbse', 'post', config, {
      timeout: 90000
    }),

  // 签发稿件到全媒体采编发（发布用的也是这个接口
  postArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0jttvf', 'post', config, {
      timeout: 90000
    }),

  // 流程记录
  getE5ActionsLogs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60bdujpot0mpht', 'get', config, vconfig),

  // 微信账号列表
  getWeixinAccounts: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bddpvout', 'get', config, vConfig),

  //添加微信账号
  addWeixinAccount: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bddpvout0bee', 'get', config),

  //原稿会彻底删除，发布库稿件会设删除标记
  postArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0efmfuf', 'post', config),
  postWeiXinArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0efmfuf', 'post', config),

  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60bdujpot0efubjmbdujpot', 'get', config),

  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  //推送微信
  postWeiXinArticlePush: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bsujdmft0qvti', 'post', config),
  //获取群发发布剩余次数
  getWeiXinArticleGetPushBalance: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bsujdmft0hfuQvtiCbmbodf',
      'get',
      config
    ),

  //推送微信平台（群组）
  postWeiXinArticleGroupsPush: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0hspvqt0qvti', 'post', config, vconfig),
  //群发发表
  postWeiXinArticleGroupsPushArticle: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bsujdmft0qvtiBsujdmf',
      'post',
      config,
      vconfig
    ),

  // 获取当前流程
  getWeixinAccountsFlow: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bddpvout0efubjm', 'GET', config),

  // 读流程的接口
  getE5Flows: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60gmpxt', 'get', config, vconfig),

  // 保存流程设置
  postWeixinAccountsFlow: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bddpvout0gmpx', 'POST', config),

  // 退出授权
  getWeixinAccountsDisable: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bddpvout0ejtbcmf', 'POST', config),
  // 删除账号
  deleteWeixinAccounts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bddpvout', 'DELETE', config),

  // 保存
  postArticlesWX: (config, vconfig) =>
    createAPI(
      config.hubConfig
        ? 'CMS:/mediax-articlewx/articles/creation'
        : '/mediax-articlewx/articles/creation',
      'post',
      { data: config.data },
      config.hubConfig
        ? { hubForward: true, hub: 'e5/hub', ...vconfig }
        : vconfig
    ),

  // 单稿校核完成
  postArticleProof: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0qsppg', 'post', config),
  postWXArticleProof: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0qsppg', 'post', config),

  // 单稿驳回
  postArticleReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0sfkfdu', 'POST', config),
  postWXArticleReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0sfkfdu', 'POST', config),

  // 单稿审核完成
  postArticlePass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0qbtt', 'POST', config),
  postWXArticlePass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0qbtt', 'POST', config),

  //写稿初始化
  initializationWXGaoJian: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bsujdmft0dsfbujpo0jojujbmj{bujpo',
      'get',
      config
    ),

  // 撤稿
  postWXArticlesRevoke: (config) =>
    createAPI('customEncryptApiName-1/0w20xfjyjo0bsujdmft0sfwplf', 'post', config),
  // 预览
  getWXGroupPreview: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0nfejby.bsujdmfxy0xfjyjo0hspvqt0qsfwjfx',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0hspvqt0qsfwjfx',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 单篇预览
  getWXArticlesPreview: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0nfejby.bsujdmfxy0xfjyjo0bsujdmft0qsfwjfx',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bsujdmft0qsfwjfx',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 新建群发写稿初始化
  getWXGroupsInitialization: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0hspvqt0jojujbmj{bujpo', 'GET', config),
  // 新建群发稿件
  postWXGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0hspvqt', 'POST', config),
  // 群发管理-操作-发布
  postWXGroupsPublish: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0hspvqt0qvcmjti',
      'POST',
      config,
      vconfig
    ),
  // 群发管理-操作-解锁
  postWXUnlocker: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60bdujpot0vompdlfs', 'POST', config),
  // 群发管理-操作-删除
  postWXDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0hspvqt0efmfuf', 'POST', config),
  // 群发管理-操作-审核通过
  postWXGroupsPass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0hspvqt0qbtt', 'POST', config),
  // 群发管理-操作-删除
  postWXGroupsDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0hspvqt0efmfuf', 'POST', config),
  // 群发管理-操作-撤稿
  postWXGroupsRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0hspvqt0sfwplf', 'POST', config),
  // 群发管理-操作-送审
  postRootArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0usbotgfs', 'POST', config),
  // 群发管理-操作-驳回
  postWXGroupsReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0sfkfdu', 'POST', config),
  // 群发管理-操作-发送到手机预览
  postWXGroupsPhonePreview: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0hspvqt0qipofQsfwjfx',
      'POST',
      config,
      vconfig
    ),
  // 群发管理-获取详情
  getWXAccountsDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bddpvout0efubjm', 'GET', config),
  // 判断是否含敏感词
  postSensitiveCheckByIDs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0tfotjujwf0difdl0czJEt', 'POST', config),
  // 单篇发送到手机预览
  postWXArticlesPhonePreview: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bsujdmft0qipofQsfwjfx', 'POST', config),

  // 群发稿件详情（我的待办用
  getWXGroupsDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0hspvqt0efubjmt', 'POST', config),
  // 微信图文稿件详情
  getArticlesDetail: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0nfejby.bsujdmfxy0bsujdmft0bsujdmfEfubjm',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0bsujdmfEfubjm',
        'get',
        { params: config.params },
        null
      )
    }
  },
  // 微信-写稿初始化-新
  getInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0dsfbujpo0joju', 'get', config),
  // 微信-写稿保存-新
  postSave: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0dsfbuf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 微信-稿件详情-新 ：
  getDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0efubjm', 'GET', config),
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0efubjm', 'get', config),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config,
      vconfig
    ),
  // 根据指定用户获取修改痕迹 - 未使用
  getArticlesTracesBySameUser: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),
  // 查看权限消息
  getDetailStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0efubjm0tubuvt', 'get', config)
}
